<template>
  <div class="hero" :class="layout" :style="{height}">
    <div class="text flex-column justify-content-center">
      <h1
        class="text-white m-0"
        data-aos="fade-down"
        data-aos-duration="1000"
        v-html="title"
      ></h1>
    </div>

    <div class="media-content">
      <img
        :src="require(`@/assets/images/smart_fit/${image}`)"
        v-if="image"
        class="rounded shadow-lg"
      />

      <video
        autoplay
        loop=""
        playsinline=""
        muted=""
        class="bg-dark"
        v-if="video"
      >
        <!--<source :src="require(`@/assets/videos/${video}`)">!-->
      </video>
    </div>
  </div>
</template>

<script>
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  name: "Hero",

  props: {
    title: String,
    video: String,
    search: Boolean,
    image: String,
    layout: String,
    height: null,
  },

  components: {
    SearchJob,
  },
};
</script>

<style lang="scss">
.hero {
  width: 100vw;
  height: 100vh;
  min-height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9;

  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.5);
  }

  &.md {
    height: 40vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  &.half {
    height: 50vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  & > .text {
    z-index: 1;
    .input-group {
      .form-control,
      .btn {
        height: calc(4rem + 2px);
        display: flex;

        &::placeholder {
          opacity: 0.5;
        }
      }
    }

    h1 {
      font-size: 3.7rem;
      font-weight: 500;
      text-align: center;
      line-height: calc(3.7rem * 1.3);
      strong {
        font-weight: 600;
      }

      @include media-breakpoint-down(md) {
        font-size: 2rem;
          line-height: calc(2rem * 1.3);
      }
    }
  }

  & > .media-content,
  & > .media-content > img,
  & > .media-content > video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    z-index: -1;
    overflow: hidden;
  }

  *::-webkit-media-controls-panel {
    display: none !important;
    -webkit-appearance: none;
  }

  *::--webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }

  *::-webkit-media-controls-start-playback-button {
    display: none !important;
    -webkit-appearance: none;
  }
}
</style>
